import { render } from "./ChatChart.vue?vue&type=template&id=1ec654ef&scoped=true"
import script from "./ChatChart.vue?vue&type=script&lang=js"
export * from "./ChatChart.vue?vue&type=script&lang=js"

import "./ChatChart.vue?vue&type=style&index=0&id=1ec654ef&scoped=true&lang=css"

import exportComponent from "/home/dyam/Documentos/BEELIA/mi-stock-beelia-vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ec654ef"]])

export default __exports__